export default "dist/images/block-header-huge.b30ab5f.png";